import React from 'react';
import { Modal, Button, Row, Col, Checkbox, Spin } from 'antd';
import { Input } from 'antd';
const Search = Input.Search;
process.env.__CLIENT__ && require('./specifications.less');
import { proxy } from 'yxyweb/common/helpers/util';


export default class Specifications extends React.Component {
    constructor(props) {
        super(props);
        this.classId = {
            SpecSums: 'productSpec',
            PropertySums: 'productArchive',
            SKUPropertySums: 'productSku',
            OrderPropertySums: 'productOrder'
        }
        this.modelTitle = {
            SpecSums: '商品规格',
            PropertySums: '商品属性',
            SKUPropertySums: 'SKU属性',
            OrderPropertySums: '订单属性'
        }
        this.state = {
            specs: [],
            index: props.index,
            isSpec: false,
            loading: true,
            specsword:'',
            listword:''
        }
    }
    componentDidMount() {
        let _this =  this;
        const config = {
            url: '/bill/ref/getRefData',
            method: 'POST',
            options: {
                domainKey: _this.props.model.getParams().domainKey
            },
            params: {
                "refCode": "pc_userdefclassref",
                "billnum": "pc_producttpl",
                "mapCondition": {
                    classId: this.classId[this.props.childrenField]
                },
                "page": {
                    "pageSize": -1,
                    "pageIndex": 1
                }
            }
        }
        proxy(config).then(json => {
            if (json.code !== 200) return;
            json.data.gridData.recordList.map(val => {
                return val['checked'] = false
            })
            let specs = json.data.gridData.recordList;
            let _data = this.props.data;
            if (!specs.length) {
                this.setState({ isSpec: true, loading: false })
                return false
            }
            _data.length && specs.map((val,index) => {
                val.default = 0 // 默认传过来的是否有值
                let _spec = _data.filter(v => val.id == v.specification || val.id == v.propertyType);
                if (_spec.length) {
                    val.checked = true
                    val.default = 1
                    let recordList;
                    switch (_this.props.childrenField) {
                        case 'SpecSums':
                            let specitemList = (_spec[0].specitem || '').split('; ');
                            let erpNameList = (_spec[0].erpName || '').split('; ');
                            recordList = specitemList.map((v,index)=>{
                                return {name:v,checked:true,erpName:erpNameList[index]}
                            })
                            break;
                        case 'PropertySums':
                        case 'SKUPropertySums':
                        case 'OrderPropertySums':
                            recordList = (_spec[0].values || '').split('; ').map(v => {
                                return { name: v, checked: true }
                            }) || []
                            break;
                        default:
                    }
                    val.recordList = recordList
                }
                return val
            })
            let _index = 0;
            if(specs.length && this.state.index!==undefined){
                let __data = _data[this.state.index];
                _index = _.findIndex(specs, function(o) { return (o['id'] === __data['specification'] || o['id'] === __data['propertyType'])});
            }
            _this.getspecitem(specs, _index, false)
        })

    }
    handleOk = (e) => {
        let _specsCheckedData = this.state.specs.filter(v => v.checked);
        if (!_specsCheckedData.length) {
            cb.utils.alert(('请选择' + this.modelTitle[this.props.childrenField] + '值'), 'warning');
            return false
        }
        if (this.props.childrenField == 'SpecSums' && _specsCheckedData.length > 5) {
            cb.utils.alert('最多选择5个规格', 'warning');
            return false
        }
        this.props.model.execute('afterHandleOK', { key: 'Specifications', value: _specsCheckedData });
        this.props.close()
    }
    getspecitem = (specs, index, isChecked) => { // 是否改变 recordList 里面checked的值
        if (!isChecked) {
            this.setState({ loading: true })
        }
        const config = {
            "url": '/bill/ref/getRefData',
            "method": 'POST',
            options: {
                domainKey: this.props.model.getParams().domainKey
            },
            "params": {
                "refCode": "pc_userdefref",
                "billnum": "pc_producttpl",
                "mapCondition": { "defineId": specs[index].defineId },
                "page": {
                    "pageSize": -1,
                    "pageIndex": 1
                }
            }
        }
        proxy(config).then(json => {
            if (json.code !== 200) return;
            let recordList = json.data.gridData.recordList
            if (specs[index].default) { // 需要合并
                recordList.map(val => {
                    specitemlist: for (let i = 0, len = specs[index].recordList.length; i < len; i++) {
                        if (val.name == specs[index].recordList[i].name) {
                            val.checked = true
                            break specitemlist;
                        }
                    }
                })
                specs[index].recordList = recordList
                specs[index].default = 0
            } else {
                specs[index].recordList = recordList;
            }
            if (isChecked) {
                isChecked = specs[index].checked
                specs[index].recordList.map(v => {
                    v.checked = isChecked
                })
            }
            this.setState({ specs, index, loading: false })
        })
    }
    handleCancel = (e) => {
        this.props.close()
    }
    handleSpecsChange = (index, e) => {
        e.stopPropagation();
        const { specs} = this.state;
        specs[index].checked = !specs[index].checked
        if (this.props.childrenField == 'SpecSums') {
            let _specsCheckedData = specs.filter(v => v.checked);
            if(_specsCheckedData.length>5){
              specs[index].checked = !specs[index].checked
              cb.utils.alert('最多选择5个规格', 'warning');
              return false
            }
        }
        if (!specs[index].recordList || specs[index].default) { //当没有子规格  ，发送请求
            // proxy 请求 当前的规格值
            this.getspecitem(specs, index, true);
        } else {
            specs[index].recordList.map(v => {
                v.checked = specs[index].checked
            })
            this.setState({ specs, index, loading: false })
        }
    }
    handleSpecsClick = (index, e) => {
        e.stopPropagation();
        let { specs } = this.state;
        if (!specs[index].recordList || specs[index].default) {
            // proxy 请求 当前的规格值
            this.getspecitem(specs, index, false)
        } else {
            this.setState({ index, loading: false })
        }
    }
    changeSpecsItem = (i, e) => {
        e.stopPropagation();
        let { specs, index } = this.state;
        specs[index].recordList[i].checked = !specs[index].recordList[i].checked
        let checked = false
        specs[index].checked = false
        specs[index].recordList.forEach(val => {
            if (!checked && val.checked) {
                checked = true
                specs[index].checked = true
            }
        })
        this.setState(specs)
    }
    onSearchChange=(e,word)=>{
      let value = e.target.value;
      this.setState({ [word]: value});
    }
    render() {
      const { specs, index, isSpec ,specsword,listword} = this.state;
    //   let _specs = specsword ? (specs.length ? specs.filter(v=>{
    //    let _val = v.showItem || v.item;
    //    return _val.indexOf(specsword)>=0
    //   }):[]):specs;
      const Specs = specs.length ? specs.map((val, index) => {
        let _val =val.showItem || val.item;
        if(_val.indexOf(specsword)===-1) return
        return <p className='clearfix' key={index} onClick={this.handleSpecsClick.bind(this,index)}>
            <Checkbox style={{float:'left'}} onChange={this.handleSpecsChange.bind(this,index)} checked={val.checked}/>
            <span title={val.showItem || val.item}>{val.showItem || val.item}</span>
          </p>
        }) : '';
        const Subspecs = specs.length && specs[index]['recordList'] && specs[index]['recordList'].length ? specs[index]['recordList'].map((val, i) => {
          if(val.name.indexOf(listword)===-1) return
          return <p key={i}>
            <Checkbox onChange={this.changeSpecsItem.bind(this,i)} checked={val.checked}>{val.name}</Checkbox>
          </p>
        }) : '';
        const IsSpec = isSpec ? <p>没有{this.modelTitle[this.props.childrenField]}</p> : ''
        const IsSubspec = (specs.length && specs[index]['recordList'] && !specs[index]['recordList'].length) ? <p>没有{this.modelTitle[this.props.childrenField]+'值'}</p> : ''
        let content = this.modelTitle[this.props.childrenField];
        return (
            <Modal
              visible={true}
              //title={'选择'+this.modelTitle[this.props.childrenField]}
              title={'选择'+this.modelTitle[this.props.childrenField]}
              width='600'
              height='500'
              onCancel={this.handleCancel}
              footer={null}
              wrapClassName='specifications'
            >
                <Spin spinning={this.state.loading}>
                <Row gutter={24}>
                 <Col span={12}>
                    <p className='code-title'>
                        {'选择'+this.modelTitle[this.props.childrenField]}
                        {
                            this.props.childrenField=='SpecSums'?
                            <em>(最多选择<i> 5 </i>个规格)</em>:
                            null
                        }
                    </p>
                    <div className='code-box-container'>
                      <Search value={specsword} onChange={(e)=>this.onSearchChange(e,'specsword')} />
                      <div className='code-box'>
                        {Specs}
                        {IsSpec}
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <p className='code-title'>{'选择值'}</p>
                    <div className='code-box-container'>
                      <Search value={listword} onChange={(e)=>this.onSearchChange(e,'listword')} />
                      <div className='code-box'>
                        {Subspecs}
                        {IsSubspec}
                      </div>
                    </div>
                  </Col>
                </Row>
                 <div className="ant-modal-footer" style={{borderTop:'none',"paddingRight":0,"paddingBottom":0}}>
                   <button type="button" className="ant-btn ant-btn-lg" onClick={this.handleCancel}><span>取 消</span></button>
                   <button type="button" className="ant-btn ant-btn-primary ant-btn-lg" onClick={this.handleOk.bind(this)}><span>确 定</span></button>
                 </div>
                </Spin>
          </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/modal/Specifications.jsx